import { createFileRoute, redirect } from '@tanstack/react-router';
import { FullPageSpinner } from '../components/layout/FullPageSpinner';
import { SignUpForm } from '../features/auth/components/SignUpForm';
import { sessionQueryOptions } from '../features/auth/auth.queries';

export const Route = createFileRoute('/sign-up')({
  beforeLoad: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (data?.user) {
      throw redirect({ to: '/' });
    }
  },
  pendingComponent: FullPageSpinner,
  component: SignUpPage,
});

function SignUpPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-background px-4">
      <div className="w-full max-w-sm">
        <SignUpForm />
      </div>
    </div>
  );
}
